<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="BulkIndexContractServiceFee"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :resourceTitle="'Contract Service Fees'|pgettext('BulkIndexContractServiceFee|ResourceTitle')"
    :resourceKey="'Indexing'|pgettext('BulkIndexContractServiceFee|ResourceKey')"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      :name="formName"
      autofocus="first"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpFormGroup
        name="percentage"
        :label="'Percentage'|pgettext('BulkIndexContractServiceFee')"
        :description="'The percentage used to calculate the indexed prices.'|pgettext('BulkIndexContractServiceFee')"
        labelColsMd="3"
        contentColsMd="4"
        :labelAlign="labelAlign"
        contentClass="input-group"
        appendText="%"
        required
      >
        <ItpFormInput
          name="percentage"
          v-model="item.percentage"
          mask="number"
          unmask="typed"
          scale="4"
          required
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        name="valid_from"
        :label="'Valid From'|pgettext('BulkIndexContractServiceFee')"
        :description="'The start date from which the new fee is valid.'|pgettext('BulkIndexContractServiceFee')"
        labelColsMd="3"
        contentColsMd="4"
        :labelAlign="labelAlign"
        required
      >
        <ItpFormDatetime
          name="valid_from"
          v-model="item.valid_from"
          required
        >
        </ItpFormDatetime>
      </ItpFormGroup>
      <ItpFormGroup
        name="new_indexation_date"
        :label="'New Indexation Date'|pgettext('BulkIndexContractServiceFee')"
        :description="'Sets the next indexation date for the related contracts.'|pgettext('BulkIndexContractServiceFee')"
        labelColsMd="3"
        contentColsMd="4"
        :labelAlign="labelAlign"
      >
        <ItpFormDatetime
          name="new_indexation_date"
          v-model="item.new_indexation_date"
        >
        </ItpFormDatetime>
      </ItpFormGroup>
      <ItpFormGroup
        name="transaction_notes"
        :label="'Transaction notes'|pgettext('ContractServiceFee')"
        labelColsMd="3"
        contentColsMd="9"
        :labelAlign="labelAlign"
      >
        <TransactionNotesEditor
          type="number"
          name="transaction_notes"
          v-model="item.transaction_notes"
          class="w-auto"
        >
        </TransactionNotesEditor>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Submit'|pgettext('Button')"
      :disabled="!forms[formName] || !forms[formName].submittable"
      type="submit"
      :form="formId"
      variant="primary"
      :icon="$config.submitIcon"
      :spinning="actions.submit.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class BulkIndexContractServiceFee extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_item = new ComponentValueCache(this, "item", "BulkIndexContractServiceFee.item");
  }

  @Prop({
    type: Array,
  })
  items!: array;

  @Watch('items')
  onItems(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("items")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  labelAlign!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  item!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['labelAlign', 'formId', 'formName', 'item', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        labelAlign: "right",
        formId: null,
        formName: "BulkIndexContractServiceFee",
        item: {
          percentage: null,
          new_indexation_date: null,
          valid_from: null,
          transaction_notes: null,
        }
        ,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("BulkIndexContractServiceFee|Title", "Indexing"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_8826_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_8826, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_8832_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_8832, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async act_1040167445267876_request_8830_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_8830, alias=submit
    return {
      operation: "bulk_index_contract_service_fee",
      data: {
        items: _.map(this.items, p => _.extend(_.pick(p, ['id', 'etag']), { value: this.item }))
      },
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_8826: actions.CloseModalAction;
    evh_7315092382398562_close_8825: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_8828: actions.CloseComponentAction;
    evh_2248226175642056_close_8827: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_8832: actions.CloseModalAction;
    evh_1040167445267876_success_8831: actions.EventHandlerImpl;
    act_1040167445267876_request_8830: actions.RequestAction;
    evh_1040167445267876_submit_8829: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_8834: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_8833: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_8826 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_8826_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_8825 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_8826,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_8825],
      }
    );
    const act_2248226175642056_closeComponent_8828 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_8827 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_8828,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_8827],
      }
    );
    const act_1040167445267876_closeModal_8832 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_8832_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_8831 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_8832,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_request_8830 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_8830_getActionArgs,
        displayName: "submit",
        events: [evh_1040167445267876_success_8831],
      }
    );
    const evh_1040167445267876_submit_8829 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_8830,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_8829],
      }
    );
    const act_1419464017721962_closeComponent_8834 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_8833 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_8834,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_8833],
      }
    );
    return {
      act_7315092382398562_closeModal_8826,
      evh_7315092382398562_close_8825,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_8828,
      evh_2248226175642056_close_8827,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_8832,
      evh_1040167445267876_success_8831,
      act_1040167445267876_request_8830,
      evh_1040167445267876_submit_8829,
      evh_1040167445267876_submit,
      act_1419464017721962_closeComponent_8834,
      evh_1419464017721962_clickPreventStop_8833,
      evh_1419464017721962_clickPreventStop,
      submit: act_1040167445267876_request_8830,
    }
  }
}

Vue.component("BulkIndexContractServiceFee", BulkIndexContractServiceFee);

</script>